/* eslint-disable no-console */
function initComparisons() {
  var slider, sliderElements, overlayElements, backgroundElements, overlay, background, sliderIndicators, sliderIndicator;
  var height;
  var isClicked = false;

  sliderElements = document.getElementsByClassName("slider-wrapper");
  overlayElements = document.getElementsByClassName("img-comp-overlay");
  backgroundElements = document.getElementsByClassName("img-comp-wrapper");
  sliderIndicators = document.getElementsByClassName("slide-indicator"); 

  slider = sliderElements[0];
  overlay = overlayElements[0];
  background = backgroundElements[0];
  sliderIndicator = sliderIndicators[0]; 

  if (!slider || !overlay || !background) return; 
 
  slider.addEventListener("mousedown", readySlide);
  slider.addEventListener("touchstart", readySlide)
  slider.addEventListener("mouseup", finishSlide);
  slider.addEventListener("touchend", finishSlide)
  overlay.addEventListener("mouseup", finishSlide);
  overlay.addEventListener("touchend", finishSlide)
  background.addEventListener("mousemove", function (event) {
    slideMove(event);
  });
  background.addEventListener("touchmove", function (event) {

    slideMove(event);
  }); 
  slider.addEventListener("touchmove", function (event) {
    slideMove(event);
  });

  function prepSlide() {

    if (sliderElements && overlayElements) {

      height = overlay.offsetHeight
        slider.style.top = (height - (slider.offsetHeight)) + "px";
        sliderIndicator.style.left = (0.5 * slider.offsetWidth - (sliderIndicator.offsetWidth / 2)) + "px";  
    }
    };

    if (window.addEventListener) {
        window.addEventListener('load', prepSlide); 
    }
    if (window.addEventListener('resize', prepSlide)); 

    function readySlide(event) {

    isClicked = true;
    event.preventDefault();
    console.log('Slider is ready'); 
  };

  function slideMove(event) {
    if (!isClicked) return; 


    var rect = background.getBoundingClientRect();
    var sliderBottom;  
    var y;
   
    if (event.type === "touchmove") {
      y = event.touches[0].clientY - rect.top;
    } else {
      y = event.clientY - rect.top;
    }

      slider.style.top = y + "px";
      overlay.style.height = (y + 10) + "px";
      sliderBottom = y + slider.offsetHeight; 

    if (parseInt(slider.style.top) < (0.11 * background.offsetHeight)) {
      slider.style.top = (0.11 * background.offsetHeight) + "px";
      overlay.style.height = (0.10 * background.offsetHeight + 10) + "px";
    } else if (sliderBottom > (0.86 * background.offsetHeight)) {
        slider.style.top = (0.84 * background.offsetHeight) + "px";
        overlay.style.height = (0.87 * background.offsetHeight) + "px"; 
    }
  };

  function finishSlide() {
    isClicked = false;
    console.log('Slider has been released');
  }

}

export default {
  initComparisons,
};
